export default __webpack_public_path__ + "static/media/newLogoLogin.194c957f.svg";